export const toTitleCase = (text) => {
    return text
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
};
/**
 * Prettifies a raw filename/slug by replacing hyphens and underscores with
 * spaces and capitalizing the first letter of each word.
 */
export const prettifyFilename = (name) => {
    return name.replace(/[-_]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};
/**
 * Converts a hex emoji code to an emoji character.
 *
 * @param emojiCode - The hex code of the emoji (e.g., "1f412")
 * @returns The emoji character or null if conversion fails
 *
 * @example
 * convertEmojiCodeToEmoji('1f412') // '🐒'
 * convertEmojiCodeToEmoji('1f600') // '😀'
 * convertEmojiCodeToEmoji(null) // null
 */
export const convertEmojiCodeToEmoji = (emojiCode) => {
    if (!emojiCode)
        return null;
    try {
        const codePoint = parseInt(emojiCode, 16);
        return String.fromCodePoint(codePoint);
    }
    catch {
        return null;
    }
};
/**
 * Truncates a string in the middle with ellipsis, like Google search results.
 *
 * @param str - String to truncate
 * @param maxLength - Maximum total length including ellipsis (default: 60)
 * @returns Truncated string with middle replaced by '...'
 *
 * @example
 * // For accessibility, provide the full string to screen readers
 * <a href={url} aria-label={url}>
 *   {truncateMiddle(url, 50)}
 * </a>
 */
export const truncateMiddle = (str, maxLength = 60, ellipsis = '…') => {
    if (str.length <= maxLength) {
        return str;
    }
    const charsToShow = maxLength - ellipsis.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);
    return str.substring(0, frontChars) + ellipsis + str.substring(str.length - backChars);
};
/**
 * Truncates a string at the end with ellipsis while preserving the beginning.
 *
 * @param str - String to truncate
 * @param maxLength - Maximum total length including ellipsis (default: 60)
 * @returns Truncated string with the end replaced by '…'
 */
export const truncateEnd = (str, maxLength = 60) => {
    if (str.length <= maxLength) {
        return str;
    }
    const ellipsis = '…';
    return str.substring(0, maxLength - ellipsis.length) + ellipsis;
};
const STRING_LIST_DELIMITER = ', ';
/**
 * Serializes a string array to a comma-separated string for API storage.
 */
export const serializeStringList = (values) => {
    return values.join(STRING_LIST_DELIMITER);
};
/**
 * Parses a comma-separated (or pipe-separated) string into a string array.
 * Returns empty array for empty/null/undefined input.
 */
const PARSE_DELIMITER_REGEX = /, |\|/; // TODO: remove legacy '|' delimiter after some time
export const parseStringList = (value) => {
    if (!value)
        return [];
    return value.split(PARSE_DELIMITER_REGEX).filter(Boolean);
};
//# sourceMappingURL=stringUtils.js.map